import {
    type GetFormForAdminResponseType,
    type GetFormForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getFormForAdmin = async (params: GetFormForAdminRequestType): Promise<GetFormForAdminResponseType> => {
    return await request<GetFormForAdminResponseType>(`/events/getFormForAdmin?formID=${params.formID}`, {
        method: "GET"
    });
};

export default getFormForAdmin;
